import styled from '@emotion/styled';
import React from 'react';
import { SlackPromoConfluenceFormView } from './slack-promo-confluence-form-views';

export function SlackPromoConfluenceStandaloneLayout() {
  return (
    <StandAloneLayoutContainer className={'layout-standalone'}>
      <StandAloneLayoutInnerContainer>
        <SlackPromoConfluenceFormView />
      </StandAloneLayoutInnerContainer>
    </StandAloneLayoutContainer>
  );
}

export const StandAloneLayoutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(9, 30, 66, 0.15);
  max-width: 414px;
  min-height: 314px;
  padding: 0 24px;
  width: 100%;
`;

export const StandAloneLayoutInnerContainer = styled.div`
  margin: 32px 0;
  width: 100%;
`;
